<template>
    <div class="menu-w selected-menu-color-light menu-activated-on-hover menu-has-selected-link color-scheme-dark sub-menu-color-bright menu-position-side menu-side-left menu-layout-mini sub-menu-style-over">

        <h1 class="menu-page-header">
            Page Header
        </h1>
        <ul class="main-menu">
            <li class="sub-header">
                <span>Dashboard</span>
            </li>
            <li class="selected has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="icon-screen-desktop"></div>
                    </div>
                    <span>Dashboard</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Dashboard
                    </div>
                    <div class="sub-menu-icon">
                        <i class="icon-screen-desktop"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/dashboard">
                                <a>Dashboard </a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </li>

            <li class="sub-header">
                <span>Desks</span>
            </li>

            <li class=" has-sub-menu" v-if="modules.includes('projectdesk')">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-tasks"></div>
                    </div>
                    <span>Project Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Project Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-tasks"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/projectdesk/projects">
                                <a>Projects</a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </li>

            <li class=" has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-tshirt"></div>
                    </div>
                    <span>Product Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Product Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-tshirt"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/productdesk/inventory">
                                <a>Inventory</a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </li>

            <li class=" has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-camera-alt"></div>
                    </div>
                    <span>Photo Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Photo Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-camera-alt"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/photodesk/sessions">
                                <a>Shoot Sessions</a>
                            </router-link>
                            <router-link tag="li" to="/photodesk/models">
                                <a>Models</a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </li>

            <li class=" has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="icon-check"></div>
                    </div>
                    <span>Pretouch Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Pretouch Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="icon-check"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/pretouchdesk/sessions">
                                <a>Review Sessions</a>
                            </router-link>
                        </ul>

                    </div>
                </div>
            </li>
            <li class=" has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-paint-brush"></div>
                    </div>
                    <span>Retouch Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Retouch Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-paint-brush"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/retouchdesk/sessions">
                                <a>Review Sessions</a>
                            </router-link>

                        </ul>
                    </div>
                </div>
            </li>
            <li class=" has-sub-menu" v-if="modules.includes('copydesk')">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-edit"></div>
                    </div>
                    <span>Copy Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Copy Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-edit"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/copydesk/sessions/write">
                                <a>Write Sessions</a>
                            </router-link>
                            <router-link tag="li" to="/copydesk/sessions/review">
                                <a>Review Sessions</a>
                            </router-link>
                            <router-link tag="li" to="/copydesk/imports">
                                <a>Copy Imports</a>
                            </router-link>
                            <router-link tag="li" to="/copydesk/templates">
                                <a>Copy Templates</a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </li>

            <li class=" has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-table"></div>
                    </div>
                    <span>Impex Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Impex Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-table"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/impexdesk/imports">
                                <a>Imports</a>
                            </router-link>
                            <router-link tag="li" to="/impexdesk/exports">
                                <a>Exports</a>
                            </router-link>

                        </ul>
                    </div>
                </div>
            </li>

            <li class=" has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-chart-line"></div>
                    </div>
                    <span>Reporting Desk</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Reporting Desk
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-chart-line"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/reportdesk/reports/worklist">
                                <a>Worklist</a>
                            </router-link>
                            <router-link tag="li" to="/reportdesk/reports/contactsheet">
                                <a>Contact Sheets</a>
                            </router-link>

                            <router-link tag="li" to="/reportdesk/reports/exported">
                                <a>Exported Reports</a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </li>

            <li class="sub-header">
                <span>Extras</span>
            </li>

            <li class=" has-sub-menu">
                <a>
                    <div class="icon-w">
                        <div class="fal fa-cogs"></div>
                    </div>
                    <span>Settings</span>
                </a>
                <div class="sub-menu-w">
                    <div class="sub-menu-header">
                        Settings
                    </div>
                    <div class="sub-menu-icon">
                        <i class="fal fa-cogs"></i>
                    </div>
                    <div class="sub-menu-i">
                        <ul class="sub-menu">
                            <router-link tag="li" to="/orgdesk/settings">
                                <a>Settings </a>
                            </router-link>

                        </ul>

                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  props: ['client', 'modules'],
  mounted () {
    this.initNav()
  },
  methods: {
    initNav () {
      // INIT MENU TO ACTIVATE ON HOVER
      var menu_timer
      $('.menu-activated-on-hover').on('mouseenter', 'ul.main-menu > li.has-sub-menu', function () {
        var $elem = $(this)
        clearTimeout(menu_timer)
        $elem.closest('ul').addClass('has-active').find('> li').removeClass('active')
        $elem.addClass('active')
      })

      $('.menu-activated-on-hover').on('mouseleave', 'ul.main-menu > li.has-sub-menu', function () {
        var $elem = $(this)
        menu_timer = setTimeout(function () {
          $elem.removeClass('active').closest('ul').removeClass('has-active')
        }, 30)
      })

      // INIT MENU TO ACTIVATE ON CLICK
      $('.menu-activated-on-click').on('click', 'li.has-sub-menu > a', function (event) {
        var $elem = $(this).closest('li')
        if ($elem.hasClass('active')) {
          $elem.removeClass('active')
        } else {
          $elem.closest('ul').find('li.active').removeClass('active')
          $elem.addClass('active')
        }
        return false
      })
    }
  },
  watch: {
    modules () {
      this.initNav()
    }
  }
}
</script>

<style scoped>
.main-menu {
    box-shadow: 0 8px 10px 0 rgba(183,192,206,.2);
    height: 100vh;
}
</style>
